export const loginProps ={
    image: {
        type: String,
        default: null
    },
    redirect: {
        default: undefined
    },
    showPanels: {
        type: Boolean,
        default: false,
    },
    imageParentClass: {
        type: String,
        default: 'col-lg-6 d-none d-lg-block',
    },
    defaultPanel: {
        default: null,
    }
}